module.exports = __webpack_public_path__ + "static/img/nombre_zurqui.34f305ef.png";